import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from '@hooks';
import { PATH_MAP } from '@constants/header';

const getHeaderTitle = path => {
    if (path.includes('/reset-password')) {
        return 'resetPassword';
    } else if (path.includes('/verify-email')) {
        return 'verifyEmail';
    }
    return PATH_MAP[path];
};

const SEO = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const title = t(`Header.${getHeaderTitle(pathname)}`);

    return (
        <Helmet>
            <title>{title} | Pluspoint</title>
            {/* Open Graph Tags */}
            <meta property="og:title" content={`${title} | Pluspoint`} />
            {/* Twitter Card Tags */}
            <meta name="twitter:title" content={`${title} | Pluspoint`} />
        </Helmet>
    );
};

export default SEO;
